

import { Link, useLocation } from 'react-router-dom';
import { HiX } from 'react-icons/hi';
import { routes } from '../routes';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import React, { useState } from 'react';

import MainLogo from '../assets/MainLogo.png';


const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  
  const menuItems = routes;

  const navigate = useNavigate();

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

const handleLogout = () => {
  // Clear auth data
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  onClose?.(); // close sidebar on mobile
  // Reload the page to reset App component state and show login page
  window.location.href = '/';
};


  return (
    <>
      {/* Overlay for mobile and md */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[100] lg:hidden transition-opacity duration-200 ease-in-out"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div
        className={`w-64 shrink-0 h-screen bg-brand flex flex-col overflow-hidden z-[110] fixed lg:static transform lg:transform-none transition-transform lg:transition-[none] duration-200 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
      {/* Logo Section */}
      <div className="p-6 border-b border-white/20">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src={MainLogo} 
              alt="Vedify Logo" 
              className="h-10 w-auto object-contain ml-2"
            />
            <span className="text-white text-2xl items-center font-extrabold">Vedify</span>
          </div>
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-lg hover:bg-white/10 transition-colors"
          >
            <HiX className="w-6 h-6 text-white" />
          </button>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 min-h-0 overflow-y-auto p-4">
        <ul className="space-y-2 pb-2">
          {menuItems.map((item) => {
            const routePath = item.path === 'dashboard' ? '/' : item.path === 'feedback' ? '/feedback' : item.path === 'faq' ? '/faq' : item.path === 'users' ? '/users' : item.path === 'karma-coins-rules' ? '/karma-coins-rules' : item.path === 'achievement' ? '/achievement' : item.path === 'app-dashboard' ? '/app-dashboard/featured' : `/${item.path}`;
            const isActive = location.pathname === routePath || (item.path === 'dashboard' && location.pathname === '/') || (item.path === 'module' && location.pathname.startsWith('/module')) || (item.path === 'practice' && location.pathname.startsWith('/practice')) || (item.path === 'meditation' && location.pathname.startsWith('/meditation')) || (item.path === 'app-dashboard' && location.pathname.startsWith('/app-dashboard'));
            return (
              <li key={item.name}>
                <Link
                  to={routePath}
                  onClick={onClose}
                  className={`w-full flex items-center gap-3 px-4 py-3 transition-all duration-200 rounded-lg ${
                    isActive
                      ? 'text-brand font-semibold bg-white'
                      : 'text-white hover:bg-white/10'
                  }`}
                >
                  {typeof item.icon === 'function' ? (
                    <item.icon className={`w-5 h-5 ${isActive ? 'text-brand' : ''}`} />
                  ) : (
                    <span className={`w-5 h-5 ${isActive ? 'text-brand' : ''}`}>{item.icon}</span>
                  )}
                  <span className="text-sm">{item.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>{/* Logout Button */}
<div className="p-4 border-t border-white/20">
<button
  onClick={() => setShowLogoutConfirm(true)}
  className="w-full flex items-center gap-3 px-4 py-3 rounded-lg
             text-white hover:bg-red-500/20 transition-all duration-200"
>
  <FiLogOut className="w-5 h-5 text-red-400" />
  <span className="text-sm font-medium">Logout</span>
</button>
{showLogoutConfirm && (
  <div className="fixed inset-0 z-[200] flex items-center justify-center">
    {/* Overlay */}
    <div
      className="absolute inset-0 bg-black bg-opacity-60"
      onClick={() => setShowLogoutConfirm(false)}
    />

    {/* Modal */}
    <div className="relative bg-white rounded-xl shadow-xl w-[90%] max-w-sm p-6 animate-scale-in">
      <h3 className="text-lg font-semibold text-gray-800">
        Confirm Logout
      </h3>
      <p className="text-sm text-gray-600 mt-2">
        Are you sure you want to logout?
      </p>

      <div className="flex justify-end gap-3 mt-6">
        <button
          onClick={() => setShowLogoutConfirm(false)}
          className="px-4 py-2 text-sm rounded-lg border border-gray-300
                     text-gray-700 hover:bg-gray-100"
        >
          Cancel
        </button>

        <button
          onClick={handleLogout}
          className="px-4 py-2 text-sm rounded-lg
                     bg-red-500 text-white hover:bg-red-600"
        >
          Logout
        </button>
      </div>
    </div>
  </div>
)}

</div>


      {/* Footer */}
      {/* <div className="p-4 border-t border-gray-200">
        <p className="text-xs text-gray-500 text-center">© 2024 BE SOCIAL</p>
      </div> */}
      </div>
    </>
  );
};

export default Sidebar;

